

export const GetMonthName =(numeroMes)=>{
    const meses = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
      ];
      
      if (numeroMes < 1 || numeroMes > 12) {
        return "Número de mes inválido";
      }
    
      const nombreMes = meses[numeroMes - 1];
      return nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);
}